// extracted by mini-css-extract-plugin
module.exports = {"responsive":"footer_responsive__VKOwy","sizeP":"footer_sizeP__2nnbN"};